import * as actionTypes from './actionTypes';
import { RequestsActionTypeMap } from './actionTypeMap';

export function beginRequest(requestId: string): RequestsActionTypeMap['BEGIN_REQUEST'] {
  return {
    payload: { requestId },
    type: actionTypes.BEGIN_REQUEST,
  };
}

export function putRequestSuccess(
  requestId: string,
  response?: unknown,
): RequestsActionTypeMap['PUT_REQUEST_SUCCESS'] {
  return {
    payload: { requestId, response },
    type: actionTypes.PUT_REQUEST_SUCCESS,
  };
}

export function putRequestError(
  requestId: string,
  error: Error,
  response?: unknown,
): RequestsActionTypeMap['PUT_REQUEST_ERROR'] {
  return {
    payload: { error, requestId, response },
    type: actionTypes.PUT_REQUEST_ERROR,
  };
}
